import { gql } from '@apollo/client';

export default gql`
  mutation addNote($bookingReference: String!, $note: String!) {
    addNote(bookingReference: $bookingReference, note: $note) {
      reference
      notes {
        uuid
        content
        author
        createdAt
      }
    }
  }
`;
